import { withPrefix } from 'gatsby'
import React, { useContext } from 'react'
import StateContext from '../state'
import { StyledHeader } from '../styles'

const Header = () => {
  const [navOpen, setNavOpen] = useContext(StateContext)

  return (
    <StyledHeader>
      <button
        onClick={() => {
          setNavOpen(!navOpen)
        }}
      >
        <svg>
          <use xlinkHref={`#${navOpen ? 'close-icon' : 'icon-show-menu'}`} />
        </svg>
      </button>
      <a
        href="https://philsinatra.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={withPrefix('/logo192.png')} alt="phil sinatra avatar" />
      </a>
    </StyledHeader>
  )
}

export default Header
